import { memo, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import '../assets/css/Common.css'
import '../assets/css/Serial.css'
import { Skeleton } from "antd"
import { Helmet } from "react-helmet"
import { getSerialByUrl } from "../services/SerialsService"
import { getImageUrl } from "../services/CommonService"
import ArticleCard from "../components/ArticleCard"


const Serial = memo(function Serial() {
    const { url } = useParams()
    const [serial, setSerial] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        let isMounted = true

        const fetchSerial = async () => {
            setLoading(true)
            setError(false)
            try {
                const data = await getSerialByUrl(url)
                if (isMounted) setSerial(data)
            } catch (err) {
                if (isMounted) setError(true)
            } finally {
                if (isMounted) setLoading(false)
            }
        }

        fetchSerial()

        return () => { isMounted = false }
    }, [url])

    const sortedArticles = serial?.articles
        ? [...serial.articles].sort((a, b) => a.seriesPosition - b.seriesPosition)
        : []

    return (
        <div className="flex-container flex-column center-align serial-div">
            {!error ? (
                <>
                    {!loading && serial && (
                        <Helmet>
                            <title>{"Historiografija.ba | " + serial.title}</title>
                        </Helmet>
                    )}

                    {!loading && serial ? (
                        <div className="serial-header">
                            <div className="serial-header-image-div">
                                <img
                                    src={getImageUrl(serial.image.imageName)}
                                    alt={serial.image.altText}
                                    className="serial-header-img"
                                />
                            </div>
                            <div className="serial-header-content">
                                <h1 className="font-weight-400 title-font-size">
                                    {serial.title}
                                </h1>
                                {serial.description && (
                                    <p className="serial-description">{serial.description}</p>
                                )}

                                {serial.sponsors && serial.sponsors.length > 0 && (
                                    <div className="serial-sponsors">
                                        <div className="serial-sponsors-list">
                                            {serial.sponsors.map((sponsor) => {
                                                const link = sponsor.websiteUrl || sponsor.url || null
                                                const content = (
                                                    <>
                                                        <img
                                                            src={getImageUrl(sponsor.logo.imageName)}
                                                            alt={sponsor.logo.altText}
                                                            className="serial-sponsor-logo"
                                                        />
                                                        <span>{sponsor.name}</span>
                                                    </>
                                                )
                                                return (
                                                    <div key={sponsor.id} className="serial-sponsor-wrapper">
                                                        <p className="serial-sponsor-disclosure">
                                                            {sponsor.disclosureText || "Podržava:"}
                                                        </p>
                                                        {link ? (
                                                            <a href={link} target="_blank" rel="noreferrer" className="serial-sponsor">
                                                                {content}
                                                            </a>
                                                        ) : (
                                                            <span className="serial-sponsor">{content}</span>
                                                        )}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="flex-container width-45p">
                            <Skeleton active paragraph={{ rows: 3 }} title={{ width: '100%' }} />
                        </div>
                    )}

                    {!loading ? (
                        sortedArticles.length !== 0 && (
                        <>
                            <h2 className="serial-articles-heading">Članci u serijalu</h2>
                            <div className="flex-container flex-wrap top-margin-5 start-content-align center-justify height-100p full-width">
                                {sortedArticles.map((article) => (
                                    <ArticleCard
                                        key={article.id}
                                        articleId={article.id}
                                        title={article.title}
                                        image={article.image}
                                        url={article.url}
                                    />
                                ))}
                            </div>
                        </>
                    )
                    ) : (
                        <div className="flex-container flex-wrap top-margin-5 start-content-align center-justify height-100p full-width">
                            {[...Array(6)].map((_, i) => (
                                <div className="flex-container flex-column flex-wrap article-grid-item" key={i}>
                                    <Skeleton active paragraph={{ rows: 0 }} title={{ width: '100%' }} />
                                </div>
                            ))}
                        </div>
                    )}
                </>
            ) : (
                <div className="flex-container flex-wrap top-margin-5 center-justify full-width">
                    {[...Array(3)].map((_, i) => (
                        <div key={i} className="card" style={{ visibility: 'hidden' }} />
                    ))}
                </div>
            )}
        </div>
    )
})

export default Serial